import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface HistoricalReport {
  data?: unknown[]
  fullBlob?: string
  name?: string
  url?: string
}

export interface HistoricalReportsState {
  error?: string | null
  historicalReportData: Record<number, HistoricalReport[]>
  hsHistoricalReportData: Record<number, HistoricalReport[]>
  isFetching: boolean
  isFetchingHs: boolean
}

export interface ReportsState {
  error?: string
  historicalReports: HistoricalReportsState
  isFetching: { BPU: boolean; CPU: boolean; HSP: boolean; K8P: boolean }
  reports: { BPU?: any; CPU?: any; HSP?: any; K8P?: any }
}

const initialHistoricalReportsState: HistoricalReportsState = {
  error: null,
  historicalReportData: {},
  hsHistoricalReportData: {},
  isFetching: false,
  isFetchingHs: false,
}

const initialState: ReportsState = {
  error: null,
  historicalReports: initialHistoricalReportsState,
  isFetching: { BPU: false, CPU: false, HSP: false, K8P: false },
  reports: { BPU: null, CPU: null, HSP: null, K8P: null },
}

const slice = createSlice({
  name: 'Reports',
  initialState,
  reducers: {
    fetchingReport(state, action: PayloadAction<string>) {
      state.error = null
      state.isFetching[action.payload] = true
      state.reports[action.payload] = null
    },
    fetchingReportSuccess(
      state,
      action: PayloadAction<{ program: string; reportData: any }>,
    ) {
      state.error = null
      state.isFetching[action.payload.program] = false
      state.reports[action.payload.program] = action.payload.reportData
    },
    fetchingReportError(
      state,
      action: PayloadAction<{ error: any; program: string }>,
    ) {
      state.error = action.payload.error
      state.isFetching[action.payload.program] = false
    },
    deleteReportsSuccess(state) {
      state.error = null
      state.isFetching = { BPU: false, CPU: false, HSP: false, K8P: false }
      state.reports = { BPU: null, CPU: null, HSP: null, K8P: null }
    },
    fetchingHistoricalReportData(state) {
      state.historicalReports.error = null
      state.historicalReports.isFetching = true
    },
    fetchingHistoricalReportDataSuccess(
      state,
      action: PayloadAction<{
        historicalReportData: HistoricalReport[]
        siteId: number
      }>,
    ) {
      state.historicalReports.error = null
      state.historicalReports.isFetching = false
      state.historicalReports.historicalReportData[action.payload.siteId] =
        action.payload.historicalReportData
    },
    fetchingHistoricalReportDataError(
      state,
      action: PayloadAction<{ error: string | null }>,
    ) {
      state.historicalReports.error = action.payload.error
      state.historicalReports.isFetching = false
    },
    fetchingHsHistoricalReportData(state) {
      state.historicalReports.error = null
      state.historicalReports.isFetchingHs = true
    },
    fetchingHsHistoricalReportDataSuccess(
      state,
      action: PayloadAction<{
        hsHistoricalReportData: HistoricalReport[]
        siteId: number
      }>,
    ) {
      state.historicalReports.error = null
      state.historicalReports.isFetchingHs = false
      state.historicalReports.hsHistoricalReportData[action.payload.siteId] =
        action.payload.hsHistoricalReportData
    },
    fetchingHsHistoricalReportDataError(
      state,
      action: PayloadAction<{ error: string | null }>,
    ) {
      state.historicalReports.error = action.payload.error
      state.historicalReports.isFetchingHs = false
    },
  },
})

export const actions = slice.actions
export default slice.reducer
